import script from "./rightline1.vue?vue&type=script&setup=true&lang=js"
export * from "./rightline1.vue?vue&type=script&setup=true&lang=js"

import "./rightline1.vue?vue&type=style&index=0&id=1c06779f&scoped=true&lang=css"
script.__scopeId = "data-v-1c06779f"

export default script